module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av751-e9175e57dca8a9645cbd6012b33e1181.jpg";